<template>
    <form @submit.prevent="apply" class="@container/filters">
        <div
            class="flex flex-col gap-4"
            :class="{
                'bg-slate-50 p-6': props.appearance === 'modal',
            }"
        >
            <div>
                <filter-label :canReset="!!pendingFilters.search" @reset="pendingFilters.search = ''">
                    Keyword Search
                </filter-label>
                <vx-input
                    v-model="pendingFilters.search"
                    ref="searchEl"
                    type="text"
                    data-test="query"
                    placeholder="Search"
                    maxlength="191"
                    size="lg"
                >
                    <template v-slot:right>
                        <font-awesome-icon widthAuto class="text-xs" :icon="faMagnifyingGlass" />
                    </template>
                </vx-input>
            </div>

            <div>
                <filter-label :canReset="!!pendingFilters.tag" @reset="pendingFilters.tag = ''"> Tag </filter-label>
                <select-tags-v2
                    v-model="pendingFilters.tag"
                    placeholder="Search"
                    :clearable="false"
                    relativeDropdown
                    size="lg"
                ></select-tags-v2>
            </div>
        </div>

        <div
            class="flex flex-col gap-2 pt-4 @[200px]/filters:flex-row"
            :class="{
                'bg-white p-6': props.appearance === 'modal',
            }"
        >
            <vx-button data-test="cancel" type="button" color="muted-light" size="lg" @click="cancel">
                Cancel
            </vx-button>
            <vx-button data-test="apply" type="submit" size="lg" block>
                Apply
                <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
            </vx-button>
        </div>
    </form>
</template>

<script setup>
import { faCircleCheck, faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { VxInput, VxButton } from '@voxie/frontend-components';
import { nextTick, onMounted, ref, watch } from 'vue';
import SelectTagsV2 from '~/components/general/SelectTagsV2.vue';
import FilterLabel from '~/components/general/FilterLabel.vue';

const props = defineProps({
    appearance: {
        type: String,
        required: false,
    },
});

const model = defineModel({
    type: Object,
    required: true,
});

const emit = defineEmits(['apply', 'cancel']);
const pendingFilters = ref({
    search: '',
    tag: '',
});

watch(
    model,
    () => {
        pendingFilters.value = { ...model.value };
    },
    {
        immediate: true,
    }
);

const cancel = async () => {
    pendingFilters.value = { ...model.value };
    emit('cancel');
};

const apply = async () => {
    model.value = { ...pendingFilters.value };
    await nextTick();
    emit('apply');
};

const searchEl = ref();
onMounted(() => {
    searchEl.value?.field?.focus?.();
});
</script>
